import logo from './logo.jpg'

export const theme = {
    color: {
      primary: "#009ed4",
      primaryHover: "#0070a2",
    },
    logoImage: logo,
    backend: "https://ihk-krefeld.epaper-publishing-one.de/",
    directory: "/kiosk",
    header: {
      customer: "",
      title: "IHK-Magazin",
      lineHeader: true,

    },
    info: [
      {
      text: 'Impressum',
      link: 'https://www.ihk-krefeld.de/de/home/impressum.html'
    },
      {
      text: 'Datenschutz',
      link: 'https://www.ihk-krefeld.de/de/home/datenschutzerklaerung.html'
    },
  ],
  };